import cx from 'classnames'
import Styles from './CreditUsage.module.scss'

import { Text } from 'blaze-ui/Text/Text'
import { Credits } from 'blaze-ui/icons/20/Credits'
import { useCreditUsage } from 'hooks/useCreditUsage'
import dayjs from 'dayjs'

export const CreditUsage = ({ className }: { className: string }) => {
  const { creditsRemaining, endDate, baseCreditsAvailable } = useCreditUsage()
  const refillDate = dayjs(endDate).add(1, 'day')

  return (
    <div className={cx(className, Styles.container)}>
      <div className={Styles.creditUsageContainer}>
        <div className={Styles.top}>
          <Credits color="var(--purple-50)" />
          <Text variant="secondary">{creditsRemaining} credits</Text>
        </div>
        <div className={Styles.bottom}>
          {baseCreditsAvailable > 0 && (
            <Text variant="metadata" color="var(--dark-40)">
              +{baseCreditsAvailable} monthly on {refillDate.format('MMM D')}
            </Text>
          )}
        </div>
      </div>
    </div>
  )
}
